const api = "https://app.transorientesas.com/api/";
const apiImage = "https://app.transorientesas.com/storage/";
// const api = "http://127.0.0.1:9111/api/";
// const apiImage = "http://127.0.0.1:9111/storage/";
export default api;
export { apiImage };